module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l content_right"
  }, [_c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    ref: "tenantVersionTab",
    attrs: {
      "data": _vm.tenantVersionList
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tenantcode",
      "label": "租户ID",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tenantname",
      "label": "租户名称",
      "width": "200px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "forceUpdateText",
      "label": "是否强制升级",
      "width": "120px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clientname",
      "label": "终端名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clienttypename",
      "label": "终端类型名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "versionname",
      "label": "终端版本名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "versionnum",
      "label": "版本号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "url",
      "label": "url",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ip",
      "label": "ip"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "certcode",
      "label": "证书"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clientversiondescr",
      "label": "描述",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sdk",
      "label": "sdk"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "paging"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.rows,
      "layout": "total, prev, pager, next",
      "total": _vm.totalSize
    },
    on: {
      "current-change": _vm.handleCurrentPage,
      "update:currentPage": function($event) {
        _vm.page = $event
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-76bd14fe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76bd14fe","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tenantVersion/Index.vue
// module id = 267
// module chunks = 0